<template>
  <base-page>
    <el-card style="margin: 5px 0px 5px 0px">
      <el-collapse accordion style="border: none">
        <el-collapse-item name="1" style="border: none">
          <template slot="title">
            <div slot="header" class="clearfix">
              <titlu-pagina Titlu="Devize nefacturate" @on_add_clicked="show_dialog()" :AdaugaVisible="false" />
            </div>
          </template>
          <div class="filtre">
            <el-form @submit.prevent.native="refresh_info()">
              <el-row style="margin: 10px" class="input-group">
                <el-col class="input-element">
                  <el-form-item label='Interval' size="mini">
                    <el-date-picker size="mini" v-model="Filters.Data" type="daterange" range-separator="-"
                      start-placeholder="Data inceput" end-placeholder="Data sfarsit"
                      :picker-options="datePickerOptions" format="dd/MM/yyyy" value-format="yyyy-MM-dd">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Numar inmatriculare" size="mini">
                    <el-input v-model="Filters.Numar" />
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Marca" size="mini">
                    <el-select v-model="Filters.Marca" @change="marcaChangeHandler()" class="full-width" filterable
                      size="mini" clearable>
                      <el-option label="Toate" value="-1" />
                      <el-option v-for="item in Info.marci" :key="'marci' + item.Id" :label="item.Nume"
                        :value="item.Id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Model" size="mini">
                    <el-select v-model="Filters.Model" @change="refresh_info" class="full-width" filterable size="mini"
                      clearable :disabled="Filters.Marca == -1 || Filters.Marca == '' || !Filters.Marca">
                      <el-option label="Toate" value="-1" />
                      <el-option v-for="item in Info.modele" :key="'modele' + item.Id" :label="item.Nume"
                        :value="item.Id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col class="input-element">
                  <el-form-item label="Tip auto" size="mini">
                    <el-select v-model="Filters.TipAuto" class="full-width">
                      <el-option label="Toate" value="-1"></el-option>
                      <el-option label="Normal" value="Normal"></el-option>
                      <el-option label="SUV" value="SUV"></el-option>
                      <el-option label="Autoutilitar" value="Autoutilitar"></el-option>
                      <el-option label="Supercar" value="Supercar"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Nume client" size="mini">
                    <el-input v-model="Filters.Client" />
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Numar deviz" size="mini">
                    <el-input v-model="Filters.IdDeviz" clearable />
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label='Centru productie' size="mini">
                    <el-select class='full-width' v-model='Filters.IdCentruProductie' filterable>
                      <el-option label='Toate' value='-1'></el-option>
                      <el-option v-for='item in Info.centre_productie' :key="'centre_productie' + item.Id"
                        :label='item.Nume' :value='item.Id' />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label='Serviciu programator' size="mini">
                    <el-select class='full-width' v-model='Filters.IdServiciuProgramator' filterable>
                      <el-option label='Toate' value='-1'></el-option>
                      <el-option v-for='item in Info.servicii_programator' :key="'serviciu_programator' + item.Id"
                        :label='item.Nume' :value='item.Id' />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Antifurt" size="mini">
                    <el-select v-model="Filters.Antifurt" class="full-width">
                      <el-option label="Toate" value="-1" />
                      <el-option label="Da" value="1" />
                      <el-option label="Nu" value="0" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Valoare Min" size="mini">
                    <el-input-number v-model="Filters.ValoareMin" :precision="0" :max="999999" :min="0" />
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Valoare Max" size="mini">
                    <el-input-number v-model="Filters.ValoareMax" :precision="0" :max="999999" :min="0" />
                  </el-form-item>
                </el-col>
                <el-col :md="24">
                  <el-button type="primary" size="mini" native-type="submit" @click="refresh_info()">
                    Aplica
                  </el-button>
                  <el-button type="danger" native-type="submit" @click="reset()" size="mini">
                    Reseteaza
                  </el-button>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-card>


    <el-table @expand-change="onRowExpand" :data="Results" ref="expandTable">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-card style="width: 80%; margin: 0 auto">

            <el-table :data="props.row.Devize">
              <el-table-column prop="Id" width="70px" label="#"></el-table-column>
              <el-table-column label="Data inchidere">
                <template slot-scope="scope">
                  {{ scope.row.DataInchiderii | DataOraFaraSec }}
                </template>
              </el-table-column>
              <el-table-column label="Data finalizare">
                <template slot-scope="scope">
                  {{ formatDate(scope.row.DataTerminareLucru) ? formatDate(scope.row.DataTerminareLucru) : '-' }}
                </template>
              </el-table-column>
              <el-table-column label="Nume utilizator" prop="NumeUtilizatorAprobare"></el-table-column>
              <el-table-column label="Antifurt" align="right">
                <template slot-scope="scope">
                  {{ scope.row.Antifurt == 0 ? "Nu" : "Da" }}
                </template>
              </el-table-column>
              <el-table-column label="Valoare Ron" align="right">
                <template slot-scope="scope">
                  {{ scope.row.ValoareDeviz | format_money }}
                </template>
              </el-table-column>
              <el-table-column v-if="device === 'computer'" align="right" fixed="right" label="Actiuni" width="250px">
                <template slot-scope="scope">
                  <el-tooltip content="Print consimtamant">
                    <el-button size="mini" icon="el-icon-printer" circle @click="print_consimtamant(scope.row.Id)" />
                  </el-tooltip>
                  <el-tooltip v-if="loggedUserId == desiredUserId" content="Inchide deviz fara factura">
                    <el-button type="danger" size="mini" icon="el-icon-close" circle
                      @click="inchide_deviz_fara_factura(scope.row.Id)" />
                  </el-tooltip>
                  <el-tooltip content="Preview">
                    <el-button type="primary" size="mini" icon="el-icon-view" circle @click="preview(scope.row.Id)" />
                  </el-tooltip>
                  <el-tooltip content="Print deviz">
                    <el-button type="info" size="mini" icon="el-icon-printer" circle
                      @click="print_deviz(scope.row.Id)" />
                  </el-tooltip>
                  <el-tooltip content="Print inspectie">
                    <el-button type="warning" size="mini" icon="el-icon-printer" circle
                      @click="print_inspectie(scope.row.Id)" />
                  </el-tooltip>
                  <el-tooltip content="Emitere factura">
                    <el-button type="success" v-if="$has_right('Receptie')" size="mini" icon="el-icon-finished" circle
                      @click="show_dialog(scope.row.Id, scope.row)" />
                  </el-tooltip>
                  <el-tooltip content="Emitere factura multipla">
                    <el-button plain v-if="$has_right('Receptie')" size="mini" icon="el-icon-document-copy" circle
                      @click="show_dialog_factura_multipla(scope.row)" />
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column v-else fixed="right" label="Actiuni" width="70px" type="expand">
                <template slot-scope="scope">
                  <div class="phone-btn">
                    <el-tooltip content="Print consimtamant">
                      <el-button size="mini" icon="el-icon-printer" circle @click="print_consimtamant(scope.row.Id)" />
                    </el-tooltip>
                    <el-tooltip content="Preview">
                      <el-button type="primary" size="mini" icon="el-icon-view" circle @click="preview(scope.row.Id)" />
                    </el-tooltip>
                    <el-tooltip content="Print deviz">
                      <el-button type="info" size="mini" icon="el-icon-printer" circle
                        @click="print_deviz(scope.row.Id)" />
                    </el-tooltip>
                    <el-tooltip content="Print inspectie">
                      <el-button type="warning" size="mini" icon="el-icon-printer" circle
                        @click="print_inspectie(scope.row.Id)" />
                    </el-tooltip>
                    <el-tooltip content="Emitere factura">
                      <el-button type="success" size="mini" v-if="$has_right('Receptie')" icon="el-icon-finished" circle
                        @click="show_dialog(scope.row.Id)" />
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </template>
      </el-table-column>
      <el-table-column prop="NumeCompletClient" label="Client"></el-table-column>
      <el-table-column prop="Numar" label="Numar"></el-table-column>

    </el-table>

    <el-dialog title="Date cu caracter personal" :visible.sync="showDialogDate" width="80%" v-loading="loader">
      <div class="container">
        <el-form label-position="top" :inline="false" label-width="100%" :model="temp_date" :ref="'my-form'"
          :rules="rules">
          <el-row :gutter="15">
            <el-col>
              <div class="group-loc">
                <el-form-item prop="nume" class="form-lj" label="Nume">
                  <el-input v-model="temp_date.nume"></el-input>
                </el-form-item>
                <el-form-item prop="prenume" class="form-lj" label="Prenume">
                  <el-input v-model="temp_date.prenume"></el-input>
                </el-form-item>
              </div>
              <div class="group-loc">
                <el-form-item prop="telefon" class="form-lj" label="Telefon">
                  <el-input v-model="temp_date.telefon"></el-input>
                </el-form-item>
                <el-form-item prop="email" class="form-lj" label="Email">
                  <el-input v-model="temp_date.email"></el-input>
                </el-form-item>
              </div>
              <el-form-item prop="tip" label="Tip persoana">
                <el-select v-model="temp_date.tip" placeholder="Tip persoana">
                  <el-option label="Fizica" value="fizica"></el-option>
                  <el-option label="Juridica" value="juridica"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <hr>
          <el-row v-if="temp_date.tip === ''">
            <p class="tip-persoana">Te rog alege tipul de persoana intai</p>
          </el-row>
          <el-row v-else-if="temp_date.tip === 'fizica'" :gutter="15">
            <!-- <p class="tip-persoana">Aici o sa vina datele pt persoanele fizice</p> -->
            <el-col>
              <el-form-item prop="adresa" id="adresa" label="Adresa">
                <el-input v-model="temp_date.adresa"></el-input>
                <!-- <VueGoogleAutocomplete id="map" v-model="temp_date.adresa"></VueGoogleAutocomplete> -->
              </el-form-item>
              <div class="group-loc">

                <el-form-item prop="judet" class="form-lj" label="Judet">
                  <!-- <el-input v-model="temp_date.judet"></el-input> -->
                  <el-select size="large" filterable v-model="temp_date.judet" @change="filtru_judet(temp_date.judet)"
                    placeholder="Alege un judet">
                    <el-option v-for="judet in Info.judete" :key="judet.Id + '_' + judet.Nume" :label="judet.Nume"
                      :value="judet.IdEvio"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="status_localitate" prop="localitate" class="form-lj" label="Localitate">
                  <!-- <el-input v-model="temp_date.localitate"></el-input> -->
                  <el-select size="large" filterable v-model="temp_date.localitate" placeholder="Alege o localitate">
                    <el-option v-for="localitate in Info.localitati" :key="localitate.Id + '_' + localitate.Nume"
                      :label="localitate.Nume" :value="localitate.IdEvio"></el-option>
                  </el-select>
                </el-form-item>
              </div>

            </el-col>
          </el-row>
          <el-row v-else-if="temp_date.tip === 'juridica'">
            <!-- <p class="tip-persoana">Aici o sa vina datele pt persoanele juritice</p> -->
            <el-form-item prop="cui" label="CUI">
              <div style="display:flex;align-items:center;gap:12px;">
                <el-input size="mini" v-model="temp_date.cui" />
                <el-button @click="verificareAnaf" size="mini">Verificare ANAF</el-button>
              </div>
            </el-form-item>


            <!-- <el-form-item prop="adresa" label="Adresa">
                <el-input v-model="temp_date.adresa"></el-input>
              </el-form-item>
            <div class="group-loc">
                <el-form-item prop="localitate" class="form-lj" label="Localitate">
                <el-input v-model="temp_date.localitate"></el-input>
              </el-form-item>
              <el-form-item prop="judet" class="form-lj" label="Judet">
                <el-input v-model="temp_date.judet"></el-input>
              </el-form-item>
           </div>
             -->
          </el-row>
          <el-row v-if="denumireFirma != ''">
            <el-col :span="24">
              <div>
                Denumire firma: {{ denumireFirma }}
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="show_dialog"> Renunta </el-button>
        <el-button type="success" @click="factureaza(temp_date.id, temp_date)"> Trimite </el-button>
      </span>
    </el-dialog>

    <el-pagination @size-change="refresh_info" @current-change="refresh_info" :page-size.sync="PaginationInfo.PerPage"
      :current-page.sync="PaginationInfo.Page" :total="PaginationInfo.RowCount" layout="pager" />
    <Previewdeviz ref="preview_deviz" />
    <devize-factura-multipla ref="devize_factura_multipla" />
  </base-page>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";
import TitluPagina from "@/widgets/TitluPagina";
import Previewdeviz from '@/components/Preview_deviz';
import Devize_factura_multipla_dialog from "./Devize_factura_multipla_dialog.vue";
import LocalSettings from "../../backend/LocalSettings";
// import VueGoogleAutocomplete from "vue-google-autocomplete";

export default {
  name: "masini",
  extends: BasePage,
  components: {
    "base-page": BasePage,
    "titlu-pagina": TitluPagina,
    Previewdeviz,
    'devize-factura-multipla': Devize_factura_multipla_dialog,
  },
  data() {
    let validateNumeric = async (rule, value, callback) => {
      if (value === undefined || value.length < 0 || value == null || this.temp_date.cui.length <= 0) return callback('Campul este obligatoriu')
      this.temp_date.cui = value.split("").filter(a => /^\d+$/.test(a)).join("");

    }
    return {
      loader: false,
      datePickerOptions: settings.datePickerOptions,
      showDialogDate: false,
      status_localitate: false,
      dateDevizeVechi: '',
      expandedRows: [],
      loggedUserId: '',
      desiredUserId: '',
      temp_date: {
        id: "",
        tip: "",
        adresa: "",
        localitate: "",
        judet: "",
        cui: "",
        nume: "",
        prenume: "",
        telefon: "",
        email: "",

      },
      device: "",
      Results: [],
      base_url: "",
      Info: {
        clienti: [],
        marci: [],
        modele: [],
      },
      Filters: {
        Data: [],
        Numar: "",
        Marca: "-1",
        Model: "-1",
        TipAuto: "-1",
        Client: "",
        IdDeviz: "",
        IdCentruProductie: "-1",
        IdServiciuProgramator: "-1",
        Antifurt: "-1",
        ValoareMin: "",
        ValoareMax: "",
      },
      denumireFirma: '',
      OrderBy: {},
      PaginationInfo: {
        Page: 1,
        PerPage: 50,
        RowCount: 0,
        PageSizes: [10, 25, 50, 100, 200],
      },
      rules: {
        cui: [{ required: true, validator: validateNumeric }],
        tip: [{ required: true, message: "Campul este obligatoriu" }],
        judet: [{ required: true, message: "Campul este obligatoriu" }],
        localitate: [{ required: true, message: "Campul este obligatoriu" }],
        adresa: [{ required: true, message: "Campul este obligatoriu" }],
        nume: [{ required: true, message: "Campul este obligatoriu" }],
        prenume: [{ required: true, message: "Campul este obligatoriu" }],
        talefon: [{ required: true, message: "Campul este obligatoriu" }],
        email: [{ required: true, message: "Campul este obligatoriu" }],

      }
    };
  },
  methods: {
    async print_consimtamant(id_deviz) {
      let isDev = '';
      if (LocalSettings.IS_DEV) { isDev = '/dev' }
      
      window.open(isDev + "/#/deviz_consimtamant_pdf/" + id_deviz, '_blank');
    },

    async filtru_judet(id) {
      let response = await this.post("receptie/devize/get_localitati_filtrate", {
        IdJudet: id,
      });
      this.Info.localitati = response.localitati;
      this.status_localitate = true;
      // console.log(response.localitati);
    },
    onRowExpand(expandedRows, expanded) {
      this.expandedRows = expanded;
    },
    async inchide_deviz_fara_factura(id) {
      try {
        this.$confirm('Devizul o sa dispara din aceasta lista si poate fi consultat ulterior din raportul de devize inchise fara factura!', 'Atentie', {
          confirmButtonText: 'Da',
          cancelButtonText: 'Nu',
          type: 'warning'
        }).then(async () => {
          const response = await this.post("receptie/devize/inchide_deviz_fara_factura", { idDeviz: id });
          this.refresh_info();
          this.$message({
            type: 'success',
            message: 'Inchiderea devizului fara factura a fost realizata cu succes!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Inchiderea a fost anulata!'
          });
        });
      } catch (error) {
        consol.error(error)
        this.$message({ type: 'error', message: 'A intervenit o eroare in inchiderea devizului fara factura!' });
      }
    },

    // upperCase() {
    //   this.temp_date.cui = this.temp_date.cui.toUpperCase()
    // },

    show_dialog(id, data) {
      // console.log(data)


      if (id && data) {
        this.temp_date = {
          id: id,
          tip: "",
          adresa: "",
          localitate: "",
          judet: "",
          cui: "",
          idClient: data.IdClient,
          nume: data.NumeClient,
          prenume: data.PrenumeClient,
          telefon: data.TelefonClient,
          email: data.EmailClient
        }
      } else {
        this.temp_date = {
          id: "",
          tip: "",
          adresa: "",
          localitate: "",
          judet: "",
          cui: "",
          nume: "",
          prenume: "",
          telefon: "",
          email: "",
        }
        this.status_localitate = false;
      }

      this.denumireFirma = '';
      this.showDialogDate = !this.showDialogDate;
    },

    formatDate(value) {
      if (!value) return '';
      const d = new Date(value);
      const z = n => (n < 10 ? '0' + n : n);
      return `${z(d.getDate())}.${z(d.getMonth() + 1)}.${d.getFullYear()} ${z(d.getHours())}:${z(d.getMinutes())}`;
    },

    show_dialog_factura_multipla(data) {
      // if (data) {
      // this.temp_date = {
      //   id: "",
      //   tip: "",
      //   adresa: "",
      //   localitate: "",
      //   judet: "",
      //   cui: "",
      //   idClient: data.IdClient,
      //   nume: data.NumeClient,
      //   prenume: data.PrenumeClient,
      //   telefon: data.TelefonClient,
      //   email: data.EmailClient
      // }

      this.$refs.devize_factura_multipla.show_me(data.IdClient, data.NumeClient, data.PrenumeClient, data.TelefonClient, data.EmailClient, this.Info.judete);
      // }
    },


    print_inspectie(id_deviz) {
      // window.open("/#/inspectie_finala/" + id_deviz, '_blank');
      let isDev = '';
      if (LocalSettings.IS_DEV) { isDev = '/dev' }
      
      window.open(isDev + "/#/inspectie_finala/" + id_deviz, '_blank');

    },

    async verificareAnaf() {
      let cui = this.temp_date.cui;
      if (cui.startsWith('RO')) {
        cui = this.temp_date.cui.substring(2).trim();
      } else {
        cui = this.temp_date.cui.trim();
      }

      const response = await this.post('receptie/devize/verificare_anaf', { cui: cui });
      if (response.Results.error) {
        this.$message({ message: 'CUI invalid', type: 'error', duration: 4500 });
      } else {
        if (!response.Results.info || response.Results.info.denumire === '') {
          this.$message({ message: 'CUI invalid', type: 'error', duration: 4500 });
        } else {
          this.denumireFirma = response.Results.info.denumire;
        }
      }
    },

    print_deviz(id_deviz) {
      // window.open("/#/deviz_produse_pdf/" + id_deviz, '_blank');
      let isDev = '';
      if (LocalSettings.IS_DEV) { isDev = '/dev' }
      
      window.open(isDev + "/#/deviz_produse_pdf/" + id_deviz, '_blank');
    },
    async factureaza(id, date) {

      this.$refs['my-form'].validate(async (valid) => {
        if (valid) {
          this.loader = true;
          if (date.tip === 'juridica') {
            date.adresa = 'notset';
            date.localitate = 'notset';
            date.judet = "notset";
          }

          let raspuns = await this.post("receptie/devize/factureaza_deviz", { IdDeviz: id, DateSuplimentare: date }, {
            headers: { 'Access-Control-Allow-Origin': '*' }
          });
          // console.log(raspuns);
          if (Number(raspuns.success) == 1) {
            this.$message({
              message: 'Factura a fost trimisa cu success',
              type: 'success'
            });
            this.loader = false;
            await this.show_dialog();
            await this.refresh_info();
          } else if (Number(raspuns.success) == 0) {

            if (typeof raspuns.EroareEvio.Mesaj != undefined) {
              this.$message({
                message: raspuns.EroareEvio.Mesaj,
                type: 'error'
              });
            } else {
              this.$message({
                message: 'A aparut o eroare la facturare.',
                type: 'error'
              });
            }
            this.loader = false;
          } else {
            this.$message({
              message: 'A aparut o eroare la facturare.',
              type: 'error'
            });
            this.loader = false;

          }
        }
      });
    },
    async preview(id) {
      this.$refs.preview_deviz.show(id)
    },

    async get_info() {
      var response = await this.post("receptie/devize/get_info");
      this.Info.clienti = response.clienti;
      this.Info.judete = response.judete;
      this.Info.centre_productie = response.centre_productie;
      this.Info.servicii_programator = response.servicii_programator;
      this.Info.marci = response.marci;
      this.loggedUserId = response.userId;
      await this.refresh_info();
    },
    async refresh_info_without_loader(first = false) {
      if (!first) {
        const response = await this.post("receptie/devize/get_devize_nefacturate", {
          Filters: this.Filters,
          OrderBy: this.OrderBy,
          PaginationInfo: this.PaginationInfo,
        });
        if (typeof response.Results != 'undefined') {
          if (this.dateDevizeVechi != '' && JSON.stringify(response.Results) == this.dateDevizeVechi) {
            console.log('nu s-a schimbat nimic in devize nefacturate')
          } else {
            this.Results = response.Results;
            this.dateDevizeVechi = JSON.stringify(response.Results)
            this.$nextTick(() => {
              this.expandedRows.forEach(row => {
                const newRow = this.Results.find(result => result.Id === row.Id);
                if (newRow) {
                  this.$refs.expandTable.toggleRowExpansion(newRow, true);
                }
              });
            });
          }
        }
      }

      clearTimeout(this.cerere);
      this.cerere = null;

      this.cerere = setTimeout(() => this.refresh_info_without_loader(), 1000 * 5);
    },


    async refresh_info() {
      var response = await this.post("receptie/devize/get_devize_nefacturate", {
        Filters: this.Filters,
        OrderBy: this.OrderBy,
        PaginationInfo: this.PaginationInfo,
      });
      this.Results = response.Results;
      this.PaginationInfo = response.PaginationInfo;
      this.dateDevizeVechi = JSON.stringify(response.Results)

    },

    async marcaChangeHandler() {
      if (!this.Filters.Marca || this.Filters.Marca == '-1') {
        this.Info.modele = [];
        this.Filters.Model = '-1';
      }
      if (this.Filters.Marca) {
        const response = await this.post("receptie/devize/get_model_for_marca", { id_marca: this.Filters.Marca });
        if (response && response.modele) {
          this.Info.modele = response.modele;
        } else {
          this.Info.modele = [];
          this.Filters.Model = '';
        }
      }

      await this.refresh_info();
    },
    reset() {
      this.Filters = {
        Data: [],
        Numar: "",
        Marca: "-1",
        Model: "-1",
        TipAuto: "-1",
        Client: "",
        IdDeviz: "",
        IdCentruProductie: "-1",
        IdServiciuProgramator: "-1",
        Antifurt: "-1",
        ValoareMin: "",
        ValoareMax: "",
      };
      this.refresh_info();
    },

  },

  created() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.device = "phone"
    } else this.device = "computer"
  },

  mounted() {
    if (!this.$has_right("Management") && !this.$has_right('Receptie')) {
      // console.log('nu are')
      this.$router.push("/no-rights");
      return;
    }


    this.select_menu_item("devize_nefacturate");
    this.base_url = settings.BASE_URL;
    this.get_info();
    this.refresh_info_without_loader(true);
    this.desiredUserId = null;

    if (window.location.href.includes("localhost") || window.location.href.includes("dev")) {
      this.desiredUserId = 36;
    } else {
      this.desiredUserId = 18;
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.cerere) {
      clearTimeout(this.cerere);
      this.cerere = null
    }
    next()
  },
  beforeDestroy() {
    if (this.cerere) {
      clearTimeout(this.cerere);
      this.cerere = null
    }
  }
};
</script>

<style lang="less" scoped>
.top50 {
  margin-top: 20px;
}

.filtre {
  .el-input-number {
    width: 100% !important;
  }
}

.btn-actiuni-group {
  display: flex;
  justify-content: center;
}

.input-element {
  width: 18%;
  margin-right: 2%;
}

.tip-persoana {
  text-align: center;
  opacity: 0.5;

}

.form-lj {
  width: 45%;
}

.group-loc {
  display: flex;
  justify-content: space-between;
}

@media only screen and (max-width: 600px) {

  .form-lj {
    width: 100%;
  }

  .group-loc {
    flex-direction: column;
  }

  .input-element {
    width: 80%;
  }

  .el-tooltip__popper {
    width: 90%;
  }

  .phone-btn {
    padding-left: 20px;
    position: -webkit-sticky;
    position: sticky;
    top: 0;
  }

  .btn-actiuni-group {
    width: 100%;
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;

    .el-tooltip {
      margin: 0;
      padding: 0;
      width: 35px;
      height: 35px;
      margin-top: 5px;
    }
  }
}
</style>
